export const PowerVoltageSystemKeys = {
  pArac: 'pArac',
  vacuumStatus: 'vacuumStatus',
  pantoStatus: 'pantoStatus',
  workshopContactor: 'workshopContactor',
  mediumVoltageBackupActivated1Vehicle: 'mediumVoltageBackupActivated1Vehicle',
  mediumVoltageBackupActivated2Vehicle: 'mediumVoltageBackupActivated2Vehicle',
  mediumVoltageBackupActivated3Vehicle: 'mediumVoltageBackupActivated3Vehicle',
  vacuumClosedPantoCannotBeRaised: 'vacuumClosedPantoCannotBeRaised',
  multipleVacuumActive: 'multipleVacuumActive',
  vacuumClosedOnInactivePanto: 'vacuumClosedOnInactivePanto',
  multiplePantographCannotBeRaised: 'multiplePantographCannotBeRaised',
  hvDisconnectorCannotBeIsolated: 'hvDisconnectorCannotBeIsolated',
  hvDisconnectorCannotBeEngaged: 'hvDisconnectorCannotBeEngaged',
  diaPantoComp: 'diaPantoComp',
  transformerLevel2Error: 'transformerLevel2Error',
  hvConfigError: 'hvConfigError',
  mediumVoltageCriticalError: 'mediumVoltageCriticalError',
  mediumVoltageContactorControlError: 'mediumVoltageContactorControlError',
  mediumVoltageErrorCabChange: 'mediumVoltageErrorCabChange',
  majorUnderVoltageError: 'majorUnderVoltageError',
  highCurrentVacuumError: 'highCurrentVacuumError',
  allPantographIsolated: 'allPantographIsolated',
  isParkModeActive: 'isParkModeActive',
  measuringBatteryVoltage: 'measuringBatteryVoltage',
  transducerHvVoltageVcbIn: 'transducerHvVoltageVcbIn',
  transducerHvCurrent: 'transducerHvCurrent',
  tempBattery: 'tempBattery',
  aBatteryCharger: 'aBatteryCharger',
  tractionTransformerTemperatureTcu: 'tractionTransformerTemperatureTcu',
  sApu3phOut: 'sApu3phOut',
  sApuOk: 'sApuOk',
  hvPresenceToAps: 'hvPresenceToAps',
  sBatteryChar: 'sBatteryChar',
  manualPowerSupplyPrivilegedLoadLp: 'manualPowerSupplyPrivilegedLoadLp',
  contactorPrivilegeLoadLp: 'contactorPrivilegeLoadLp',
  tempFaultApuInv: 'tempFaultApuInv',
  tempFaultApuRec: 'tempFaultApuRec',
  inhibitAps: 'inhibitAps',
  highDisconnectorOpenedIsolated: 'highDisconnectorOpenedIsolated',
  hvDisconnectorClose: 'hvDisconnectorClose',
  pantographInsulated: 'pantographInsulated',
  earthingSwitchOpenServicePosition: 'earthingSwitchOpenServicePosition',
  vcbClosed: 'vcbClosed',
  pressurePs1SafeguardAdd: 'pressurePs1SafeguardAdd',
  tractionTransformerOverPressure11: 'tractionTransformerOverPressure11',
  tractionTransformerOverTemp1: 'tractionTransformerOverTemp1',
  tractionTransformerOverTemp2: 'tractionTransformerOverTemp2',
  tractionTransformerOilFlow: 'tractionTransformerOilFlow',
  tractionTransformerOilLevel: 'tractionTransformerOilLevel',
  fastLowering: 'fastLowering',
  openVcbForHighCurrent: 'openVcbForHighCurrent',
  fastOpeningFromSignallingTcu: 'fastOpeningFromSignallingTcu'
} as const;
